// extracted by mini-css-extract-plugin
module.exports = {"layout":"Surveys_layout__1WE93"};